import {createSlice} from "@reduxjs/toolkit";
import {json} from "../../lib/appfuse-react/core/json";

const name = 'organization';

const initialState = {
    change: {},
};

const slice = createSlice({
    name,
    initialState,
    reducers: {
        setChange(state, action) {
            state.change = json.toJSON(action.payload);
        },
    }
})

export const { setChange } = slice.actions;
export const { reducer } = slice;

export const selectChange = state => json.fromJSON(state[name].change);

const organizationReducer = reducer;
export default organizationReducer;